import { SubTitle } from "../../styled-components/utils/containerStyles";
import {
  ContactForm,
  FormControl,
  FormError,
  Input,
  Select,
  SubmitButton,
  TextArea,
} from "../contact/contactStyles";
import { HelperText } from "./careerStyles";
import { Formik } from "formik";
import internSchema, {
  errorNotify,
  initialValues,
  notify,
} from "./internFormSchema";
import { ToastContainer } from "react-toastify";
import { LoadingDiv } from "../../styled-components/utils/LoadingDiv";
import { useState } from "react";
import axios from "axios";

const InternshipForm = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={internSchema}
      onSubmit={async (values, { setFieldError, resetForm, setSubmitting }) => {
        setSubmitting(true);
        const { file } = values;
        // handle file first
        if (!file) {
          setFieldError("file", "Insert A File here");
          errorNotify("Please Attach Proper File");
          setSubmitting(false);
          return;
        }
        if (file.type !== "application/pdf") {
          setFieldError("file", "Insert A File here");
          errorNotify("Please Attach Proper File");
          setSubmitting(false);
          return;
        }
        //0.5mb only not more than that
        if (file.size > 0.5 * 1024 * 1024) {
          setFieldError("file", "File Size Exceeds 512kb");
          errorNotify("File Size Should Not be more than 512kb");
          setSubmitting(false);
          return;
        }
        const formData = new FormData();
        Object.entries(values).forEach((value) => {
          formData.append(value[0], value[1]);
        });
        try {
          const { data } = await axios.post("/api/internship", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          if (data.success) {
            notify();
            setIsSubmitted(true);
            resetForm();
          } else {
            setSubmitting(false);
            throw new Error("Failed");
          }
        } catch (error) {
          setSubmitting(false);
          errorNotify(error.message);
        }
        setSubmitting(false);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
      }) => (
        <ContactForm onSubmit={handleSubmit}>
          <ToastContainer />
          <SubTitle>We are hiring currently</SubTitle>
          <HelperText>You can drop your Details below</HelperText>
          <FormControl>
            <Input
              placeholder="Your Name"
              type="text"
              name="name"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.name}
            />
            {errors.name && touched.name ? (
              <FormError>{errors.name}</FormError>
            ) : null}
          </FormControl>
          <FormControl>
            <Input
              placeholder="City"
              type="text"
              name="city"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.city}
            />
            {errors.city && touched.city ? (
              <FormError>{errors.city}</FormError>
            ) : null}
          </FormControl>
          <FormControl>
            <Select
              id="internshipType"
              placeholder="internshipType"
              name="internshipType"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.internshipType}
              style={{ padding: "10px" }}
            >
              <option value="">Mode of Internship</option>
              <option value="Online Internship">Online Internship</option>
              <option value="Offline Internship">Offline Internship</option>
            </Select>
            {errors.internshipType && touched.internshipType ? (
              <FormError>{errors.internshipType}</FormError>
            ) : null}
          </FormControl>
          <FormControl>
            <Input
              placeholder="Your Email"
              type="email"
              name="email"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email}
            />
            {errors.email && touched.email ? (
              <FormError>{errors.email}</FormError>
            ) : null}
          </FormControl>
          <FormControl>
            <Input
              placeholder="Your Number"
              type="number"
              name="phNumber"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.phNumber}
            />
            {errors.phNumber && touched.phNumber ? (
              <FormError>{errors.phNumber}</FormError>
            ) : null}
          </FormControl>
          <FormControl>
            <Input
              placeholder="Your Resume"
              type="file"
              name="file"
              onChange={(event) => {
                setFieldValue("file", event.currentTarget.files[0]);
              }}
            />
            {errors.file ? (
              <FormError>{errors.file}</FormError>
            ) : (
              <HelperText style={{ marginTop: "1px", color: "#eed202" }}>
                Please Input a valid pdf file not more than 512kb
              </HelperText>
            )}
          </FormControl>
          <FormControl>
            <TextArea
              rows="5"
              placeholder="About You"
              type="numnber"
              name="about"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.about}
            />
            {errors.about && touched.about ? (
              <FormError>{errors.about}</FormError>
            ) : null}
          </FormControl>
          <SubmitButton type="submit" disabled={isSubmitting || isSubmitted}>
            {isSubmitted ? (
              "Thanks, We will be in touch soon"
            ) : isSubmitting ? (
              <LoadingDiv />
            ) : (
              "Join Us"
            )}
          </SubmitButton>
        </ContactForm>
      )}
    </Formik>
  );
};

export default InternshipForm;
